export const plateTextSearchHelper = (plate: string) => {
  if (plate?.length >= 3) {
    const plateSplited = plate?.replace('-', '').split('');
    const firstLetter = isNaN(parseInt(plateSplited[0], 10));
    const secondLetter = isNaN(parseInt(plateSplited[1], 10));
    const thirdLetter = isNaN(parseInt(plateSplited[2], 10));
    const plateIsFromBrazil = firstLetter && secondLetter && thirdLetter;

    const plateFromInput = plate?.replace('-', '');

    if (plateIsFromBrazil) {
      return `${plateFromInput.substring(0, 3)}-${plateFromInput.substring(3)}`;
    }
  }

  return plate;
};
